






import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  name: 'files',
  props: {},
  components: {
  },
  data: () => ({
    outdatedPeople: [],
    fields: [
      { key: 'name', label: 'Jméno' },
      { key: 'lastUpdated', label: 'Upraveno' },
      { key: 'contactPhone', label: 'Telefon' },
      { key: 'contactEmail', label: 'E-mail' },
      { key: 'note', label: 'Poznámka' }

    ]

  }),
  mounted () {
    this.loadPeople()
  },
  methods: {

    loadPeople () {
      axios
        .get('/api/v1/people-outdated')
        .then(response => {
          this.outdatedPeople = response.data
        })
        .catch(response => {
          console.log('loadFiles Error: ' + response)
        })
    }

  }
})
